var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.noTransition ? '' : 'fade'}},[_c('div',{class:['loader', { 'loader--transparent': _vm.transparent }]},[_c('b-spinner',{attrs:{"label":"Loading..."}}),(_vm.text)?_c('p',{staticClass:"loader__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }